// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8969565f","165":"5c3b995e","370":"1211bbde","435":"c79007bc","471":"e7b5bc5f","535":"93f1dcac","551":"ef12cce8"}[chunkId] + ".chunk.js";
};